// src/pages/SettingsPage.js
import React, { useState } from 'react'
import {
  Wrench,
  Bell,
  Trash2,
  Star,
  AlertTriangle,
  Target,
  CheckCircle,
  LayoutGrid,
  MessageSquare,
  Ticket, // ✅ 1. WAJIB ADA: Icon Ticket
  Smartphone, // 👈 TAMBAHAN: Icon untuk Update Versi
  ArrowLeft,  // 👈 TAMBAHAN: Icon untuk Tombol Back
} from 'lucide-react'

// =====================================================
// 🔹 KOMPONEN EXISTING
// =====================================================
import CleanOldMessages from './CleanOldMessages'
import CleanOldNotifications from './CleanOldNotifications'
import RatingsPage from './RatingsPage'
import WarningsPage from './WarningsPage'

// =====================================================
// 🔹 MISI
// =====================================================
import MissionsPage from './missions/MissionsPage'
import MissionClaimsPage from './missions/MissionClaimsPage'

// =====================================================
// 🔹 PROMO & FEEDBACK
// =====================================================
import PromoCardsPage from './PromoCardsPage'
import FeedbacksPage from './FeedbacksPage'

// ✅ 2. WAJIB ADA: Import file ManagePromosPage
import ManagePromosPage from './ManagePromosPage' 

// 👈 TAMBAHAN: Import file pengaturan versi mitra
import DriverVersionPage from './DriverVersionPage' // 👈 TAMBAHAN BARU: Zimo Driver
import AppVersionPage from './AppVersionPage'
import AppVersionCustomerPage from './AppVersionCustomerPage' 

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState('general')

  // =====================================================
  // 🔹 RENDER KONTEN TAB
  // =====================================================
  const renderTabContent = () => {
    switch (activeTab) {
      case 'messages':
        return <CleanOldMessages />

      case 'notifications':
        return <CleanOldNotifications />

      case 'ratings':
        return <RatingsPage />

      case 'warnings':
        return <WarningsPage />
      
      // 🎴 PROMO CARDS (Promo Mitra)
      case 'promo_cards':
        return <PromoCardsPage />
        
      // ✅ 3. WAJIB ADA: Case untuk menampilkan ManagePromosPage
      case 'manage_promos':
        return <ManagePromosPage />

      // 📩 FEEDBACK MITRA
      case 'feedbacks':
        return <FeedbacksPage />

      // 🎯 MANAJEMEN MISI
      case 'missions':
        return <MissionsPage />

      // ✅ APPROVAL KLAIM MISI
      case 'mission_claims':
        return <MissionClaimsPage />

      // 👈 TAMBAHAN BARU: Tampilan Halaman Update Versi Zimo Driver
      case 'app_version_driver':
        return <DriverVersionPage />

      // 👈 TAMBAHAN: Tampilan Halaman Update Versi
      case 'app_version':
        return <AppVersionPage />

      // 👈 TAMBAHAN BARU
      case 'app_version_customer':
        return <AppVersionCustomerPage />

      default:
        return (
          <div className="p-6 text-gray-100">
            <h2 className="text-xl font-semibold mb-3 flex items-center gap-2 text-blue-400">
              ⚙️ Pengaturan Umum
            </h2>
            <p className="text-gray-300 text-sm leading-relaxed">
              Halaman ini menampung pengaturan sistem Zimo.
              <br />
              Gunakan menu di kiri untuk mengelola sistem.
            </p>
          </div>
        )
    }
  }

  // =====================================================
  // 🔹 UI UTAMA
  // =====================================================
  return (
    <div className="flex h-full bg-gray-900 text-white">
      {/* ================= SIDEBAR ================= */}
      <aside className="w-64 border-r border-gray-800 bg-gray-950 flex flex-col">
        {/* 👈 TAMBAHAN: Header dengan tombol Back */}
        <div className="p-5 border-b border-gray-800 flex items-center justify-between">
          <div>
            <h2 className="font-semibold text-white">⚙️ Pengaturan</h2>
            <p className="text-xs text-gray-500">Manajemen sistem Zimo</p>
          </div>
          <button
            onClick={() => window.history.back()} // 👈 Fungsi Back Bawaan Browser
            className="p-2 bg-gray-800 hover:bg-red-600 rounded-lg text-gray-300 transition-colors"
            title="Kembali"
          >
            <ArrowLeft size={18} />
          </button>
        </div>

        {/* ================= NAVIGASI ================= */}
        <nav className="p-3 space-y-2 text-sm overflow-y-auto">
          {/* UMUM */}
          <button
            onClick={() => setActiveTab('general')}
            className={navClass(activeTab === 'general')}
          >
            <Wrench size={16} /> Umum
          </button>

          {/* 👈 TAMBAHAN BARU: Menu Update Versi Zimo Driver */}
          <button
            onClick={() => setActiveTab('app_version_driver')}
            className={navClass(activeTab === 'app_version_driver')}
          >
            <Smartphone size={16} /> Versi Zimo Driver
          </button>

          {/* 👈 TAMBAHAN: Menu Update Versi Mitra */}
          <button
            onClick={() => setActiveTab('app_version')}
            className={navClass(activeTab === 'app_version')}
          >
            <Smartphone size={16} /> Versi App Mitra
          </button>
          {/* 👈 TAMBAHAN BARU */}
          <button
            onClick={() => setActiveTab('app_version_customer')}
            className={navClass(activeTab === 'app_version_customer')}
          >
            <Smartphone size={16} /> Versi Zimo App
          </button>

          {/* SECTION PROMOSI */}
          <div className="pt-3 mt-2 border-t border-gray-800 text-xs font-bold text-gray-500 uppercase px-2">
            Promosi
          </div>

          {/* PROMO CARDS (MITRA) */}
          <button
            onClick={() => setActiveTab('promo_cards')}
            className={navClass(activeTab === 'promo_cards')}
          >
            <LayoutGrid size={16} /> Promo Mitra
          </button>

          {/* ✅ 4. WAJIB ADA: Tombol Navigasi Kode Promo (App) */}
          <button
            onClick={() => setActiveTab('manage_promos')}
            className={navClass(activeTab === 'manage_promos')}
          >
            <Ticket size={16} /> Kode Promo (App)
          </button>

          {/* SECTION MODERASI */}
          <div className="pt-3 mt-2 border-t border-gray-800 text-xs font-bold text-gray-500 uppercase px-2">
            Moderasi
          </div>

          {/* PESAN */}
          <button
            onClick={() => setActiveTab('messages')}
            className={navClass(activeTab === 'messages')}
          >
            <Trash2 size={16} /> Hapus Pesan Lama
          </button>

          {/* NOTIFIKASI */}
          <button
            onClick={() => setActiveTab('notifications')}
            className={navClass(activeTab === 'notifications')}
          >
            <Bell size={16} /> Notifikasi
          </button>

          {/* RATING */}
          <button
            onClick={() => setActiveTab('ratings')}
            className={navClass(activeTab === 'ratings')}
          >
            <Star size={16} /> Rating & Ulasan
          </button>

          {/* FEEDBACK MITRA */}
          <button
            onClick={() => setActiveTab('feedbacks')}
            className={navClass(activeTab === 'feedbacks')}
          >
            <MessageSquare size={16} /> Feedback Mitra
          </button>

          {/* WARNING */}
          <button
            onClick={() => setActiveTab('warnings')}
            className={navClass(activeTab === 'warnings')}
          >
            <AlertTriangle size={16} /> Peringatan Mitra
          </button>

          {/* SECTION MISI */}
          <div className="pt-3 mt-3 border-t border-gray-800 text-xs font-bold text-gray-500 uppercase px-2">
            Misi Mitra
          </div>

          {/* MANAJEMEN MISI */}
          <button
            onClick={() => setActiveTab('missions')}
            className={navClass(activeTab === 'missions')}
          >
            <Target size={16} /> Manajemen Misi
          </button>

          {/* APPROVAL KLAIM */}
          <button
            onClick={() => setActiveTab('mission_claims')}
            className={navClass(activeTab === 'mission_claims')}
          >
            <CheckCircle size={16} /> Klaim Misi
          </button>
        </nav>
      </aside>

      {/* ================= KONTEN ================= */}
      <main className="flex-1 p-6 overflow-y-auto bg-gray-900">
        {renderTabContent()}
      </main>
    </div>
  )
}

// Helper Style
function navClass(active) {
  return `flex items-center gap-2 w-full px-3 py-2 rounded-lg transition ${
    active ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-800'
  }`
}